import { Game } from "./Game";
import { Application, Assets, Sprite, Texture } from "pixi.js";
import { Subject } from "../utils/Subject";
import { loadTextures } from "./Textures";
import { Keyboard } from "./Keyboard";

export class RestartableGame {
	public readonly uiUpdateRequested = new Subject<never>();
	public readonly app: Application = new Application();
	private readonly keyboard: Keyboard = new Keyboard();
	game: Game | null = null;

	public async init() {
		await this.app.init({
			width: 640,
			height: 640,
			antialias: false,
			backgroundColor: 0x3AC5B9
		});
		await loadTextures();
		this.game = new Game(true, this.app, this.uiUpdateRequested, this.keyboard);
		this.app.ticker.maxFPS = 60;
		this.app.ticker.add(() => this.tick(this.app.ticker.deltaMS));
	}

	private tick(deltaMS: number) {
		this.game?.tick(deltaMS);
		// if (this.game?.shouldRestart) this.game = new Game(false, this.app, this.uiUpdateRequested);
	}
}
